import { NumberField } from 'Shared/forms/Inputs';
import { LabelOnLeftWrap } from 'Shared/forms/Wrap';

export function Brightness()
{
	return (
		<LabelOnLeftWrap label='Brightness (%)' narrow={true}>
			<NumberField field='brightness' />
		</LabelOnLeftWrap>
	);
}

